import gql from 'graphql-tag';
import { GuestSchema } from '../../definitions/schemas';
import Interface from '../Interface';

interface SearchParticipantsInput {
  roomId?: string;
  search: string;
}

interface SearchParticipantsData {
  participants: GuestSchema[];
}

export default class RoomParticipantsInterface extends Interface {
  public async search(variables: SearchParticipantsInput) {
    const response = await this.query<SearchParticipantsData>(
      () =>
        this.apolloService.executeQuery<SearchParticipantsData>({
          query: gql`
            query participants($search: String!, $roomId: ID) {
              participants(search: $search, roomId: $roomId) {
                id
                email
                firstName
                lastName
                photo
                type
              }
            }
          `,
          variables,
        }),
      'Error loading options'
    );

    return response.participants;
  }
}
